<template lang="pug">
	nav.pagination(role="navigation", aria-label="Pagination Navigation")
		a.pagination__btn.pagination__first(
			href="", 
			aria-label="Goto Page 1",
			:class="{disabled: currentPage === 0}",
			:disabled="currentPage === 0",
			@click.prevent="handleNavBtnClick($event, -currentPage)"
		) 
		a.pagination__btn.pagination__previous(
			href="", 
			:aria-label="`Goto Previous Page, page number ${currentPage}`",
			@click.prevent="handleNavBtnClick($event, -1)",
			:class="{disabled: !enablePrev}",
			:disabled="!enablePrev"
		) 
		.pagination__label
			span.pagination__current(
				:aria-label="`Current Page, page number ${currentPage + 1}`"
			) {{ currentPage + 1 }}
			span.pagination__of &nbsp;of&nbsp; 
			span.pagination__total(:aria-label="`Total page count is ${totalPages}`") {{ totalPages }}
		a.pagination__btn.pagination__next(
			href="", 
			:aria-label="`Goto Next Page, page number ${currentPage + 2}`",
			@click.prevent="handleNavBtnClick($event, 1)",
			:class="{disabled: !enableNext}",
			:disabled="!enableNext",
		) 
		a.pagination__btn.pagination__last(
			href="", 
			:aria-label="`Goto Last Page, page number ${totalPages}`",
			:class="{disabled: currentPage === totalPages - 1}",
			:disabled="currentPage === totalPages - 1",
			@click.prevent="handleNavBtnClick($event, totalPages - currentPage - 1)"
		) 
</template>

<script>

export default {
	name: "CustomPagination",
	components: {},
	props: {
		navigate: Function,
		enableNext: Boolean,
		enablePrev: Boolean,
		totalPages: Number,
		currentPage: Number,
	},
	data() {
		return {
			
		}
	},
	computed: {
		
	},
	methods: {
		handleNavBtnClick(e, diff) {
			if (!e.target.matches("[disabled]")) this.navigate(diff);
		}
	},
	created() {
		
	}
}
</script>

<style lang="scss" scoped>
#bluesearch {
	.pagination {
		margin: 0 auto;
		&__btn {
			&.disabled {
				color: $disabledGray;
				cursor: default;
			}
			&:hover {
				text-decoration: none;
				&:not(.disabled),
				&:not([disabled]) {
					background: $mediumBlue;
					color: $white;
				}
			}
		}
	}
}
</style>